import { QUESTIONS, createReader } from './documentData'
import { GOODS_EN, formatCompletionDate, formatNumber, translate } from './guideData'

// Perguntas do Lineup por porão: cubagem em m³ ("CONVERSÃO (m³)") e as 4 de "Veneno (kg)". Cada uma das 4 só aparece para uma dosagem
// (1, 2, 3 ou 4 g/m³), então só uma é respondida e a soma dá a quantidade de fumigante do porão.
const HOLDS = {
  1: { cubic: 201, fumigant: [202, 204, 200, 207] },
  2: { cubic: 210, fumigant: [212, 214, 216, 218] },
  3: { cubic: 221, fumigant: [223, 225, 227, 229] },
  4: { cubic: 232, fumigant: [234, 236, 238, 240] },
  5: { cubic: 243, fumigant: [245, 247, 249, 251] },
  6: { cubic: 198, fumigant: [255, 257, 259, 261] },
  7: { cubic: 264, fumigant: [266, 268, 270, 272] },
  8: { cubic: 275, fumigant: [277, 279, 281, 283] },
  9: { cubic: 286, fumigant: [288, 290, 292, 294] }
}

const AUTHORIZATION_QUESTIONS = {
  selectedHolds: 196, // seleção múltipla, opções "1" a "9"
  totalCubic: 339 // "CONVERSÃO TOTAL (m³)"
}

// Soma só o que foi respondido; sem resposta numérica dá 0
const sum = values =>
  values
    .map(Number)
    .filter(Number.isFinite)
    .reduce((total, value) => total + value, 0)

export const buildAuthorizationData = ({ serviceOrder, childrenServiceOrders = [], assets = [] }) => {
  const { answer } = createReader({ serviceOrder, childrenServiceOrders, assets })
  const number = questionId => Number(answer(questionId)) || 0

  const goods = answer(QUESTIONS.goods).toUpperCase()
  const quantity = formatNumber(answer(QUESTIONS.quantity), 3)
  const completionDate = formatCompletionDate(serviceOrder.endDate).monthYear
  const selected = answer(AUTHORIZATION_QUESTIONS.selectedHolds).split(', ').map(Number)

  // só os porões marcados na pergunta 196, em ordem crescente
  const holds = Object.keys(HOLDS)
    .map(Number)
    .filter(hold => selected.includes(hold))
    .map(hold => ({
      hold,
      cubic: formatNumber(number(HOLDS[hold].cubic), 3),
      fumigant: sum(HOLDS[hold].fumigant.map(answer))
    }))

  return {
    activityCode: serviceOrder.yearlyId || '',
    communicationNumber: answer(QUESTIONS.communicationNumber),
    ship: answer(QUESTIONS.ship).toUpperCase(),
    goodsPt: goods,
    goodsEn: translate(GOODS_EN, goods),
    quantity,
    dateEn: completionDate.en,
    datePt: completionDate.pt,
    holds: holds.map(row => ({ ...row, fumigant: formatNumber(row.fumigant) })),
    totalCubic: formatNumber(number(AUTHORIZATION_QUESTIONS.totalCubic), 3),
    totalFumigant: formatNumber(sum(holds.map(row => row.fumigant))),
    mapaPort: answer(QUESTIONS.mapaPort).toUpperCase()
  }
}
